export const Suptitle = ({ label }: { label: string }) => {
  return (
    <span
      className="text-blue-200"
    >
      {label}
    </span>
  )
}

export const Title = ({ label }: { label: string }) => {
  return (

  <h2
    className="text-4xl xl:text-6xl leading-20 font-extrabold text-white"
  >
    {label}
  </h2>
  )
}
